var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStarHalfFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-star-half-filled",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.418,
    height: 17.541,
    viewBox: "0 0 18.418 17.541",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M173.556,725.118V711.337l-2.7,5.471-6.038.877,4.369,4.259-1.031,6.013Z",
    transform: "translate(-164.347 -710.888)",
    fill: "#d7b369"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M178.927,728.4a.465.465,0,0,1-.219-.055l-5.181-2.724-5.181,2.724a.47.47,0,0,1-.683-.5l.989-5.769-4.192-4.086a.472.472,0,0,1,.261-.8l5.792-.84,2.591-5.25a.491.491,0,0,1,.844,0l2.59,5.25,5.793.84a.472.472,0,0,1,.261.8l-4.192,4.086.989,5.769a.47.47,0,0,1-.187.461A.465.465,0,0,1,178.927,728.4ZM165.8,717.986l3.686,3.593a.473.473,0,0,1,.136.417l-.87,5.073,4.555-2.4a.475.475,0,0,1,.439,0l4.555,2.4L177.431,722a.47.47,0,0,1,.136-.417l3.685-3.593-5.092-.739a.472.472,0,0,1-.355-.257l-2.278-4.617-2.278,4.617a.473.473,0,0,1-.355.257Z",
    transform: "translate(-164.318 -710.86)",
    fill: "#333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarHalfFilled);
export default __webpack_public_path__ + "static/media/icon-star-half-filled.a8183b0c9cdde5d3bd2552f351d73bff.svg";
export { ForwardRef as ReactComponent };